export function isMobile() {
    return Boolean(window.navigator?.userAgent?.match?.(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i));
}
